import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { usePageSeo } from '@/hooks/usePageSeo';

const NotFound = () => {
  const location = useLocation();

  usePageSeo({
    title: 'Page Not Found | PropertyTaxHero',
    description: 'The page you are looking for could not be found.',
    path: location.pathname,
    noindex: true,
  });

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center max-w-md p-6">
          <h1 className="text-5xl font-bold mb-6 text-tax-purple">404</h1>
          <p className="text-xl text-gray-600 mb-8">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <Button asChild className="bg-tax-blue hover:bg-tax-darkBlue">
            <Link to="/">Return to Home</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
